import * as React from 'react';
import { FC } from 'react';

import { NumberInput } from 'components/ucl/number-input';
import { useRedeemRewardState } from 'pages/cart/cart-item/hooks/use-redeem-reward-state';
import {
  MAX_IN_RESTAURANT_CART_QUANTITY,
  MIN_IN_RESTAURANT_CART_QUANTITY,
} from 'state/loyalty/in-restaurant-redemption';

import { displayValueStyleProps, incrementorStyleProps } from './styled';
import { IInRestaurantIncrementorProps } from './types';

const RewardRedemptionIncrementor: FC<React.PropsWithChildren<IInRestaurantIncrementorProps>> = ({
  onChange,
  quantity,
  details,
}) => {
  const {
    incentiveNotInMenu,
    limitPerOrderMet,
    hasSufficientBalance,
    redeemRewardLoading,
  } = useRedeemRewardState({
    reward: details.engineReward,
    quantity,
    cartId: details.engineReward.id,
  });
  const disableIncrement = incentiveNotInMenu || limitPerOrderMet || !hasSufficientBalance;

  return (
    <NumberInput
      ariaLabel={`${quantity}`}
      min={MIN_IN_RESTAURANT_CART_QUANTITY}
      max={MAX_IN_RESTAURANT_CART_QUANTITY}
      value={quantity}
      onChange={onChange}
      disableIncrement={disableIncrement}
      disabled={redeemRewardLoading}
      decrementAriaLabel={`Decrement ${quantity} quantity`}
      incrementAriaLabel={`Increment ${quantity} quantity`}
      displayValueStyleProps={displayValueStyleProps}
      incrementorStyleProps={incrementorStyleProps}
      hideNumberInput
      displayedValue={quantity}
    />
  );
};

export default RewardRedemptionIncrementor;
